import Vue from 'vue'
import Router from 'vue-router'
import Cardapio from "../components/Paginas/Cardapio";
import Produto from "../components/Paginas/Produto";
import Pedido from "../components/Paginas/Pedido";
import Erro from "../components/Paginas/Erro";
import Inicio from "../components/Paginas/Inicio";
import Grupo from "../components/Paginas/Grupo";
import Pesquisa from "../components/Paginas/Pesquisa";
import ReciboPagamentoLinkMercadoPago from "../components/Paginas/ReciboPagamentoLinkMercadoPago";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Erro',
      component: Erro
    },
    {
      path: '/:empresa',
      name: 'Inicio',
      component: Inicio
    },
    {
      path: '/:empresa/menu',
      name: 'Cardapio',
      component: Cardapio
    },
    {
      path: '/:empresa/menu/produto/:id',
      name: 'Produto',
      component: Produto
    },
    {
      path: '/:empresa/menu/pesquisar',
      name: 'Pesquisa',
      component: Pesquisa
    },
    {
      path: '/:empresa/menu/grupo/:id/secao/:id',
      name: 'Grupo',
      component: Grupo
    },
    {
      path: '/:empresa/pedido',
      name: 'Pedido',
      component: Pedido
    },
    {
      path: '/404/nao-localizado',
      name: 'EmpresaNaoLocalizada',
      component: Erro
    },
    {
      path: '/pagamentos/mercadopago/rastrear/:id',
      name: 'ReciboPagamentoLinkMercadoPago',
      component: ReciboPagamentoLinkMercadoPago
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js